import type { PropsWithChildren } from "react";
import { AuthProvider } from "@/features/auth";
import { FinanceCommandRecovery } from "@/features/finance/components/FinanceCommandRecovery";
// Registers every slice-owned quick-view type before any route can mount an
// EntityPeekProvider; see src/app/peek-registrations.ts for the mechanism.
import "@/app/peek-registrations";

/** Wraps the app in providers that must sit above every route. */
export function AppProviders({ children }: PropsWithChildren) {
  return (
    <AuthProvider>
      <FinanceCommandRecovery />
      {children}
    </AuthProvider>
  );
}
